import { IColumn } from "@fluentui/react";

export type OrderDisplay = {
  postId: number;
  description: string;
  amount: number;
  sent: boolean;
  orderNumber: string;
  kStatus: string;
  orderClassification?: string;
  installationComplete?: string;
  notAllHasOrderNumber: boolean;
  hasError: boolean;
  errors: string[];
};

export const columns: IColumn[] = [
  {
    key: "sent",
    name: "",
    fieldName: "sent",
    minWidth: 23,
    maxWidth: 23,
    isResizable: false,
    className: "table__center-column",
  },
  { key: "postId", name: "Leveranse ID", fieldName: "postId", minWidth: 60, maxWidth: 86, isResizable: true },
  { key: "kStatus", name: "K.status", fieldName: "kStatus", minWidth: 60, maxWidth: 80, isResizable: true },
  {
    key: "description",
    name: "Beskrivelse",
    fieldName: "description",
    minWidth: 60,
    isResizable: true,
  },
  { key: "amount", name: "Beløp", fieldName: "amount", minWidth: 50, maxWidth: 80, isResizable: true },
  { key: "orderNumber", name: "OrdreNr", fieldName: "orderNumber", minWidth: 60, isResizable: true },
  {
    key: "orderClassification",
    name: "Ordreklassifisering",
    fieldName: "orderClassification",
    minWidth: 60,
    isResizable: true,
  },
  {
    key: "installationComplete",
    name: "PFM", // Prosjektert ferdig montert
    fieldName: "installationComplete",
    minWidth: 90,
    isResizable: false,
  },
];
